// extracted by mini-css-extract-plugin
export default {"formItem":"Editable_formItem__PP+LN","formInput":"Editable_formInput__8tqej"};